<template>
    <div class="pt-15 animated fadeIn equipmentList chartOfAccount staticPageInner bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @new-item="modals.create = true"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @import-items="importItems"
                            @delete-items="deleteItems"
                            ref="gofixTable">
                            <template slot="gofix_table:last_date_modifined" slot-scope="data">
                                {{data.item.last_date_modifined  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:before-control-right" slot-scope="data">
                                <div class="mr-4 d-flex align-items-center filterCompany">
                                    <span class="mr-3 title">Finance Company</span>
                                    <gofix-form-dropdown
                                        class="highlightDropdown chartOfAccountDropdown"
                                        label=""
                                        vLabel="name"
                                        :reduce="option => option.name"
                                        :searchable="false"
                                        placeholder="Filter by company"
                                        :options="financeCompanies"
                                        v-model="coa_company_filter" />
                                </div>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>

            <!-- Create/Edit modal -->
            <b-modal
                id="modal-Create"
                title="Create COA Item"
                hide-footer :centered="true"
                ref="modal-createCOAitem"
                @hidden="refreshDataObj"
                v-model="modals.create">
                <b-form class="formV2 pb-20" v-bind:class="{'run-loading':loadings.create}">
                    <b-row>
                        <b-col sm="6">
                            <gofix-form-input label="GL code" v-model="COAobj.gl_code"></gofix-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <gofix-form-input label="GL Name" v-model="COAobj.name"></gofix-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <gofix-form-dropdown
                                    label="Finance Company"
                                    vLabel="name"
                                    :required="true"
                                    v-model="COAobj.coa_company"
                                    :options="financeCompanies">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <gofix-form-input-number label="Incom Balance" v-model="COAobj.income_balance" :allowDecimal="false" allowNegative></gofix-form-input-number>
                        </b-col>
                        <b-col sm="6">
                            <gofix-form-dropdown
                                    label="Block"
                                    v-model="COAobj.blocked"
                                    :options="['Yes','No']">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <gofix-form-dropdown
                                    label="Direct Posting"
                                    v-model="COAobj.direct_posting"
                                    :options="['Yes','No']">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col sm="6">
                            <gofix-form-input-date
                                    v-model="COAobj.last_date_modifined"
                                    label="Last Date Modified">
                            </gofix-form-input-date>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <gofix-form-dropdown
                                    label="Account Type"
                                    v-model="COAobj.account_type"
                                    :options="[1,2,3,4,5]">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col sm="6">
                            <gofix-form-dropdown
                                    label="Indentation"
                                    v-model="COAobj.indentation"
                                    :options="[1,2,3,4,5]">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <gofix-form-input label="Totaling" v-model="COAobj.totalling"></gofix-form-input>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.chart_of_account, 'create')">
                    <gofix-button label="SUBMIT" @click="createOrUpdateData" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';

    import moment from 'moment';
    const accounting = require('accounting');

    export default {
        name: 'chart-of-account',
        components: {},
        data() {
            let filter = JSON.parse(JSON.stringify(filters['chart_of_account']));
            return {
                tableConfig:{
                    name: 'finance-chart-of-account',
                    controls:{
                        create: this.$checkRole(this.$accessModule.chart_of_account, 'create'),
                        delete: this.$checkRole(this.$accessModule.chart_of_account, 'delete')
                    },
                    dataSelect:{
                        company_name:{
                            value: [],
                            value_field: 'name',
                            text_field: 'name'
                        }
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "gl_code",
                    sortDirection: "asc",
                },
                tableItems: [],
                coa_company_filter: null,
                modals:{
                    create : false,
                    import: false
                },
                loadings:{
                    list:false,
                    create:false,
                    import: false
                },
                COAobj:{
                    id:null,
                    gl_code: null,
                    name: null,
                    income_balance: null,
                    blocked: null,
                    direct_posting: null,
                    last_date_modifined: null,
                    account_type: null,
                    indentation: null,
                    totalling: null,
                    coa_company: null,
                    coa_company_id: null,
                },
                financeCompanies:[],
            }
        },
        computed: {
            ...mapGetters({
                currentRoles: 'AuthController/roles',
            })
        },
        watch : {
            coa_company_filter: function (val) {
                this.$refs.gofixTable.reloadTableItems();
            },
            "currentRoles": function(val,old){
                this.tableConfig.controls = {
                    create: this.$checkRole(this.$accessModule.chart_of_account, 'create'),
                    delete: this.$checkRole(this.$accessModule.chart_of_account, 'delete')
                }
            }
        },
        created(){
            this.getFinanceCompanies();
        },
        methods: {
            /*-- Table callback --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if(this.coa_company_filter){
                    tableRequest.filter.company_name.value = this.coa_company_filter;
                }
                await this.$store.dispatch("ChartOfAccountController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the chart of account", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                this.COAobj = {
                    id: item.id,
                    gl_code: item.gl_code,
                    name: item.name,
                    income_balance: item.income_balance,
                    blocked: item.blocked ? "Yes":"No",
                    direct_posting: item.direct_posting ? "Yes":"No",
                    last_date_modifined: item.last_date_modifined ? new Date(moment(item.last_date_modifined, "YYYY-MM-DD HH:mm:ss").toISOString()) : null,
                    account_type: item.account_type,
                    indentation: item.indentation,
                    totalling: item.totalling,
                    coa_company_id: item.coa_company_id,
                    coa_company: {
                        id: item.coa_company_id,
                        name: item.company_name,
                    },
                };
                this.modals.create = true;
            },
            async importItems(callback){
                const { file, resolve, reject } = await callback();
                await this.$store.dispatch(`ChartOfAccountController/importItems`, {
                    fileImport: file
                }).then(response => {
                    let variant = 'success';
                    let msg = this.$notificationV2('importing', 'chart_of_account');
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    this.$alertNotification(msg, variant);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('ChartOfAccountController/deleteItems', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'chart_of_account'))
                    })
                    .catch(err => {
                        reject();
                    })
            },
            /*-----------------------------------------------*/
            createOrUpdateData(){
                let action = "createItem";
                let keyMessage = 'adding';
                if(this.COAobj.id){
                    action = "updateItem";
                    keyMessage = 'editing';
                }
                let bug = false;
                if(!this.COAobj.gl_code){
                    this.$alertNotification("Please enter GL code", "danger");
                    bug = true;
                }
                if(!this.COAobj.name){
                    this.$alertNotification("Please enter name", "danger");
                    bug = true;
                }
                if(!this.COAobj.coa_company){
                    this.$alertNotification("Please select a company", "danger");
                    bug = true;
                }
                if(bug) return;

                let data = Object.assign({},this.COAobj);
                data.coa_company_id = data.coa_company ? data.coa_company.id : null;
                data.income_balance = data.income_balance ? accounting.unformat(data.income_balance) : null;

                if(data.last_date_modifined) data.last_date_modifined = moment(data.last_date_modifined).format("YYYY-MM-DD");

                this.loadings.create = true;
                this.$store.dispatch(`ChartOfAccountController/${action}`,data)
                    .then(response => {
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.loadings.create = false;
                        this.modals.create = false;
                        this.$alertNotification(this.$notificationV2(keyMessage, 'chart_of_account'));
                    })
                    .catch(err => {
                        this.loadings.create = false;
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    })
            },
            refreshDataObj(){
                this.COAobj = {
                    id: null,
                    gl_code: null,
                    name: null,
                    income_balance: null,
                    blocked: null,
                    direct_posting: null,
                    last_date_modifined: null,
                    account_type: null,
                    indentation: null,
                    totalling: null,
                };
            },
            getFinanceCompanies(){
                this.$store.dispatch("ChartOfAccountController/getCompanies", {
                    limit: -1,
                    page: 1
                }).then(response => {
                    this.financeCompanies = response.items;
                    this.tableConfig.dataSelect.company_name.value = response.items;
                    this.$refs.gofixTable.setConfig("dataSelect",this.tableConfig.dataSelect);
                })
                .catch(err => {
                    console.log(err);
                })
            }
        }
    }
</script>
